"use client";

import { Suspense } from "react";
import { useFiltersUrlSync } from "@/hooks/useTrendsQueries";

function FiltersUrlSyncInner() {
  useFiltersUrlSync();
  return null;
}

export default function FiltersUrlSyncClient() {
  return (
    <Suspense fallback={null}>
      <FiltersUrlSyncInner />
    </Suspense>
  );
}

